module.exports = { raw: '9.2.3' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 10
// module chunks = 0 1